<template>
<div id="reporte_pedimentos_ws" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Consulta Líneas de Captura" class="elevation-1 px-5 py-3" >
                    <br>
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab :key="'in-view'" >Vista Previa</v-tab>
                        <v-tab :key="'in-report'" >Generar en Reporte</v-tab>
                        <v-tab :key="'txt-report'" >Generar TXT de Consulta</v-tab>
                        <v-tab :key="'in-layout'" >Carga Layout</v-tab>
                        <v-tab-item :key="'in-view'" >
                            <v-card-text>
                                <v-card-title>
                                    <span class="headline" ></span>
                                </v-card-title>
                                <v-form ref="form1" lazy-validation>
                                    <v-container grid-list-md text-xs-center>
                                        <v-row>
                                            <v-col sm="12" md="6" lg="6" xl="6">
                                                <v-autocomplete v-model="model.rfc" :items="rfcs" :hide-no-data="true" :return-object="false" 
                                                    item-text="text" item-value="id" label="RFC" @change="cargarTodos()" :rules="[rules.required]">
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-layout row wrap>
                                            <v-flex x12 s6 m6 l6>
                                                <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Reporte" @change="clear_values()" :rules="[rules.required]" >
                                                </v-autocomplete>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout v-if="model.tipo_reporte == 1" row wrap>
                                            <v-flex s12 m6 l6>
                                                <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required]" ></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout v-if="model.tipo_reporte == 3" row wrap>
                                            <v-flex s12 m6 l6>

                                                <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                    <template v-slot:activator="{ on }" >
                                                        <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaInicio, validaFecha]" >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu3 = false" >
                                                        <v-spacer />

                                                        <v-btn color="secondary" x-small @click="menu3 = false" >
                                                            Cancelar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex s12 m6 l6>
                                                <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                    <template v-slot:activator="{ on }" >
                                                        <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" ></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu4 = false" >
                                                        <v-spacer />

                                                        <v-btn color="secondary" x-small @click="menu4 = false" >
                                                            Cancelar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>

                                            </v-flex>
                                        </v-layout>

                                        <v-layout v-if="model.tipo_reporte == 4" row wrap>
                                            <v-flex s12 m6 l6>
                                                <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]" ></v-textarea>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn rounded color="success" @click="get_data_view()" :loading="loading" >
                                    <v-icon>done</v-icon>Vista Previa
                                </v-btn>
                            </v-card-actions>
                            <v-card-text>
                                <v-client-table ref="vuetable" :data="data_view.datos" :columns="data_view.columns" :options="data_view.options" class="elevation-2 pa-2 scroll-table" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>
                                    <template slot="Origen" slot-scope="props">
                                        <span v-if="props.row.Origen == 'Robot'">A</span>
                                        <span v-if="props.row.Origen == 'Layout'">M</span>
                                    </template>
                                    <template slot="actions_view" slot-scope="props" >
                                        <v-speed-dial v-show="props.row.pdf!=''" :id="'id-2'" direction="left" open-on-hover :style="'text-align:center;'" >
                                            <template v-slot:activator>
                                                <v-btn :id="'id-2'" x-small fab dark color="primary" >
                                                    <v-icon>reorder</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-btn x-small fab dark color="red" v-if="props.row.pdf" @click="downloadFile(props.row.pdf)" title="PDF Pedimento" v-tippy>
                                                <v-icon>picture_as_pdf</v-icon>
                                            </v-btn>
                                        </v-speed-dial>
                                    </template>
                                </v-client-table>
                            </v-card-text>
                        </v-tab-item>
                        <v-tab-item :key="'in-report'" >
                            <v-card-text>
                                <v-card-title>
                                    <span class="headline" ></span>
                                </v-card-title>
                                <v-form ref="form2" lazy-validation>
                                    <v-container grid-list-md text-xs-center>
                                        <v-row>
                                            <v-col sm="12" md="6" lg="6" xl="6">
                                                <v-autocomplete v-model="model.rfc" :items="rfcs" :hide-no-data="true" :return-object="false" 
                                                    item-text="text" item-value="id" label="RFC" @change="cargarTodos()" :rules="[rules.required]">
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-layout row wrap>
                                            <v-flex x12 s6 m6 l6>
                                                <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Reporte" @change="clear_values()" :rules="[rules.required]" >
                                                </v-autocomplete>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout v-if="model.tipo_reporte == 1" row wrap>
                                            <v-flex s12 m6 l6>
                                                <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required]" ></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout v-if="model.tipo_reporte == 3" row wrap>
                                            <v-flex s12 m6 l6>
                                                <v-menu offset-x  ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                    <template v-slot:activator="{ on }" >
                                                        <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaInicio, validaFecha]" >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                                                        <v-spacer />

                                                        <v-btn color="secondary" x-small @click="menu1 = false" >
                                                            Cancelar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex s12 m6 l6>
                                                <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                    <template v-slot:activator="{ on }" >
                                                        <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                                                        <v-spacer />

                                                        <v-btn color="secondary" x-small @click="menu2 = false" >
                                                            Cancelar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>

                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-if="model.tipo_reporte == 4" row wrap>
                                            <v-flex s12 m6 l6>
                                                <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]" ></v-textarea>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn rounded color="success" @click="generar_reporte_sqs" :loading="loading" >
                                    <v-icon>done</v-icon>Generar Reporte
                                </v-btn>
                            </v-card-actions>
                            <v-card-text>
                                <v-refresh-button :funcion="cargar" />                                  

                                <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>
                                </v-client-table>
                            </v-card-text>
                        </v-tab-item>
                        <v-tab-item :key="'txt-report'" >
                            <v-card-text>
                                <v-card-title>
                                    <span class="headline" ></span>
                                </v-card-title>
                                <v-form ref="form3" lazy-validation>
                                    <v-container grid-list-md text-xs-center>
                                        <v-row>
                                            <v-col sm="12" md="6" lg="6" xl="6">
                                                <v-autocomplete v-model="model.rfc" :items="rfcs" :hide-no-data="true" :return-object="false" 
                                                    item-text="text" item-value="id" label="RFC" @change="cargarTodos()" :rules="[rules.required]">
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-layout row wrap>
                                            <v-flex x12 s6 m6 l6>
                                                <v-autocomplete v-model="model.tipo_reporte" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Reporte" @change="clear_values()" :rules="[rules.required]" >
                                                </v-autocomplete>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout v-if="model.tipo_reporte == 1" row wrap>
                                            <v-flex s12 m6 l6>
                                                <v-text-field v-model="model.pedimento" label="Pedimento" prepend-icon="fa-search" :rules="[rules.required]" ></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout v-if="model.tipo_reporte == 3" row wrap>
                                            <v-flex s12 m6 l6>
                                                <v-menu offset-x  ref="menu12" v-model="menu12" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                    <template v-slot:activator="{ on }" >
                                                        <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaMeses, validaInicio, validaFecha]" >
                                                        </v-text-field>
                                                    </template>

                                                    <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu12 = false" >
                                                        <v-spacer />

                                                        <v-btn color="secondary" x-small @click="menu12 = false" >
                                                            Cancelar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex s12 m6 l6>
                                                <v-menu offset-x ref="menu22" v-model="menu22" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                    <template v-slot:activator="{ on }" >
                                                        <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaMeses, validaFecha]" ></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu22 = false" >
                                                        <v-spacer />

                                                        <v-btn color="secondary" x-small @click="menu22 = false" >
                                                            Cancelar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>

                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-if="model.tipo_reporte == 4" row wrap>
                                            <v-flex s12 m6 l6>
                                                <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]" ></v-textarea>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn rounded color="success" @click="generar_reporte_txt" :loading="loading" >
                                    <v-icon>done</v-icon>Generar TXT
                                </v-btn>
                            </v-card-actions>
                            <v-card-text>
                                <v-refresh-button :funcion="cargartxt" />                                  

                                <v-client-table ref="vuetable" :data="datostxt" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>
                                </v-client-table>
                            </v-card-text>
                        </v-tab-item>
                        <v-tab-item :key="'in-layout'" >
                            <v-container fluid fill-height>
                                <v-layout align-center justify-center>                                    
                                    <v-flex xs12>
                                        <v-card>
                                            <v-card-actions>
                                                <v-row>
                                                    <v-col sm="12" md="10" lg="10" xl="10">
                                                        <v-autocomplete v-model="model.rfc" :items="rfcs" :hide-no-data="true" :return-object="false" 
                                                            item-text="text" item-value="id" label="RFC" @change="cargarTodos()" :rules="[rules.required]">
                                                        </v-autocomplete>
                                                    </v-col>
                                                </v-row>
                                                <v-spacer></v-spacer>
                                                <v-speed-dial direction="left" open-on-hover v-show="(model.rfc!=null && model.rfc!='')">
                                                    <template v-slot:activator>
                                                        <v-btn x-small fab dark color="primary" >
                                                            <v-icon>reorder</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                                                    <exportar-excel :data="consulta.camposLayout" :exportFields="consulta.encabezadoLayout" name="Layout Lineas de Captura.xlsx" >
                                                        <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                                            <v-icon dark>receipt</v-icon>
                                                        </v-btn>
                                                    </exportar-excel>
                                                </v-speed-dial>

                                            </v-card-actions>

                                            <v-card-text>
                                                
                                                <div id="datagrid" >
                                                    <v-refresh-button :funcion="cargarConsultas" />                                                      
                                                    <v-client-table ref="vuetable" :data="consulta.items" :columns="consulta.columns" :options="consulta.options" class="elevation-2 pa-2" >
                                                        <template slot="noResults" >
                                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                                                        </template>

                                                        <template slot="actions" slot-scope="props" >
                                                            <span v-if="props.row.estatus == 0" >
                                                                Pendiente
                                                            </span>
                                                            <span v-else-if="props.row.estatus == 1" >
                                                                En Proceso
                                                            </span>
                                                            <span v-else>
                                                                <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                                                    <template v-slot:activator>
                                                                        <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                                            <v-icon>reorder</v-icon>
                                                                        </v-btn>
                                                                    </template>

                                                                    <v-btn x-small fab dark color="blue"
                                                                        @click.native="verificaDetalle(props.row.id)" title="Volver a verificar" v-tippy>
                                                                        <v-icon>send</v-icon>
                                                                    </v-btn>

                                                                    <v-btn x-small fab dark color="primary"
                                                                        @click.native="getDetalle(props.row.id)" title="Ver detalle" v-tippy>
                                                                        <v-icon>search</v-icon>
                                                                    </v-btn>
                                                                </v-speed-dial>
                                                            </span>

                                                        </template>
                                                    </v-client-table>
                                                </div>

                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>
                    </v-tabs>

                    <!-- MODAL DETALLES -->
                    <v-dialog v-model="modal" max-width="80%" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal" >
                                    <v-icon class="white--text" >list</v-icon>&nbsp;
                                    <span class="subheading" >
                                        <strong>Detalle Líneas de Captura</strong>
                                    </span>
                                </v-card>
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modal = false" class="close_modal" >
                                    <v-icon class="white--text" >cancel</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <exportar-excel :data="data_detalle" :exportFields="data_detalle_excel" name="Detalle_Lineas_Captura.xlsx" >
                                    <v-btn dark small color="success" title="Exportar Detalle" v-tippy>
                                        <v-icon dark>get_app</v-icon> Exportar Detalle
                                    </v-btn>
                                </exportar-excel>
                            </v-card-actions>
                            <v-card-text>
                                <v-client-table ref="vuetabledetalle" :data="data_detalle" :columns="columns_detalle" :options="options_detalle" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                    </template>  
                                    <template slot="localizado" slot-scope="props" >
                                        <div class="columnaCriterio" >
                                        {{ props.row.localizado }} 
                                        </div>
                                    </template>                                                                      
                                </v-client-table>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modal = false" >
                                    <v-icon>cancel</v-icon>Cerrar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import GridLoader from "vue-spinner/src/GridLoader.vue";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    components: {
        "v-refresh-button": RefreshButton,
        loader: GridLoader
    },
    created: function () {
        this.URL = this.$hostname + "reportes/";
        this.URL_layout = "https://apivucem.econnectpro.mx/linea_captura/";
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");
        
        var tipoUsuario = this.$local_storage.get("tipo_usuario");        
        if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario")
            this.permisoEliminar = true;
        this.get_clientes_grupo();
    },
    data: () => ({
        rfcs:[],
        permisoEliminar: false,
        tab: null,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/admin"
            },
            {
                text: "Consulta Líneas de Captura",
                disabled: true,
                to: ""
            }
        ],
        tipos: [{
            "id": 1,
            "text": "Por Pedimento"
        }, {
            "id": 3,
            "text": "Por Fechas"
        }, {
            "id": 4,
            "text": "Por Lista de Pedimentos"
        }],
        URL: "",
        datos: [],
        datostxt: [],
        columns: ["id","fecha_solicitud", "usuario_email", "criterio", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["id","fecha_solicitud", "usuario_email", "criterio", "fecha_generacion", "estatus", "error"],
            sortable: ["id","fecha_solicitud", "usuario_email", "criterio", "fecha_generacion", "estatus", "error"],

            headings: {
                id:"No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Descargar"
            }
        },
        loading: true,
        show_loading: true,
        model: {
            rfc: "",
            usuario: "",
            pedimento: "",
            fecha_de: "",
            fecha_a: "",
            lista: "",
            reporte_url: "/reportes_ws/linea_captura/",
            nombre_reporte: "Conciliación Lineas de Captura",
            tipo: "Linea Captura",
            tipo_reporte: "",
        },
        menu1: false,
        menu2: false,
        menu12: false,
        menu22: false,
        menu3: false,
        menu4: false,
        rules: {
            required: v => !!v || "Este campo es requerido",
        },
        data_view: {
            datos: [],
            columns: ['Banco', 'Linea Captura',
                // 'Otra Referencia', 
                'Importe', 'Fecha Cargo Edo Cuenta',
                'Operación Bancaria',
                // 'Transacción SAT',
                'Total Contribuciones Pagadas en Pedimento', 'Diferencias',
                'No Pedimento', 'Fecha Pago Real', 'Origen',
                // 'Fecha Entrada', 'Clave Documento', 'Tipo Pedimento',
                // 'Conteo Remesas', 'Tipo Operacion','Valor Dólares','Valor en MN','Total Fletes',
                // 'Total Seguros','Total Embalajes','Otros Incrementables','Valor Aduana',
                'actions_view'
            ],            
            options: {
                filterable: true,
                sortable: [],

                headings: {
                    actions_view: 'Documentos'
                }
            }
        },
        camposObligatorios: [
            "banco",
            "aduana",
            "patente",
            "pedimento",
            "importe",
            "fecha",
        ],
        consulta: {
            columns: ["id", "fecha_creacion", "username", "fecha_actualizacion",'actions'],
            options: {
                filterable: ["id", "fecha_creacion", "username", "fecha_actualizacion"],
                sortable: ["id", "fecha_creacion", "username", "fecha_actualizacion"],

                headings: {
                    id:"No. Proceso",
                    fecha_creacion: "Fecha Solicitud",
                    username: "Usuario",
                    fecha_actualizacion: "Fecha Actualización",
                    actions: "Opciones"
                }
            },
            selected: [],
            camposexcel: {
                "Banco": "banco",
                "Referencia": "referencia",
                "Importe": "efectivo",
                "Fecha de Cargo": "fecha",
                "Estatus": "estatus"
            },
            items: [],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                banco: "banco",
                linea: "linea",
                otros:"otros",
                importe: "importe",
                fecha:"fecha",
                aduana:"aduana",
                patente:"patente",
                pedimento:"pedimento",
                numero_operacion_bancaria: "numero_operacion_bancaria",
                numero_transaccion_sat: "numero_transaccion_sat",
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                banco: "[Banco]",
                linea: "[Línea de Captura 20 caracteres, ejemplo: 032001AJO6P127331222]",
                otros:"[Otras referencias de Pago]",
                importe: "[Importe]",
                fecha: "[Fecha de Cargo]",
                aduana: "[Numero de aduana 2 digitos]",
                patente:"[Número de Patente 4 dígitos]",
                pedimento:"[Número de Pedimento 7 dígitos]",
                numero_operacion_bancaria: "[Número operación bancaria - Opcional]",
                numero_transaccion_sat: "[Número Transaccion SAT - Opcional]",
            }]
        },
        importData: [],
        modal: false,
        data_detalle:[],
        data_detalle_excel: {
                "Banco": "banco",
                "Línea Captura": "linea_captura",
                "Otras referencias": "otros",
                "Importe": "importe",
                "Fecha Cargo Edo Cuenta": "fecha",
                "Aduana": "aduana",
                "Patente": "patente",
                "Pedimento": "pedimento",
                "No. Operación Bancaria":"numero_operacion_bancaria",
                "No. Transacción SAT":"numero_transaccion_sat",
                "Pago Aplicado a Pedimento":"aplicado",
                "Pedimento Encontrado":"localizado"
            },
        columns_detalle: ["banco", "linea_captura", "otros", "importe", "fecha",'aduana','patente','pedimento',
            'numero_operacion_bancaria','numero_transaccion_sat',"aplicado",'localizado'],
        options_detalle: {
                headings: {
                    "banco":"Banco",
                    "linea_captura":"Línea Captura",
                    "otros":"Otras referencias",
                    "importe":"Importe",
                    "fecha":"Fecha Cargo Edo Cuenta",
                    "patente":"Patente",
                    "pedimento":"Pedimento",
                    "numero_operacion_bancaria":"No. Operación Bancaria",
                    "numero_transaccion_sat":"No. Transacción SAT",
                    "aplicado": "Pago Aplicado a Pedimento",
                    "localizado": "Pedimento Encontrado"
                }
            },
    }),
     computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.consulta.items;
            }

        },
    },
    methods: {
        cargarTodos: function(){
            this.cargar();
            this.cargartxt();
            this.cargarConsultas();
        },
        get_clientes_grupo: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var data = {
                usuario: this.$local_storage.get("id_usuario"),
                sistema: this.$sistema,
            };

            axios.post(this.$hostname + "usuarios/get_clientes_grupo/", data)
                .then(res => {
                if (res.data != undefined) {
                    this.rfcs= res.data;
                } else {
                    this.rfcs = [];
                }
                })
                .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los RFC del Grupo.",
                    footer: ""
                });
                console.log(err);

                }).then(() => {
                this.$root.$dialogLoader.hide();
                });
        },
        validaFecha: function(fecha){        
             if (fecha == "Invalid date")
                return "Fecha no válida.";
            else 
              return true;
            return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."                
            }
            return true;
        },
        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
                if (Math.abs(diferencia) > 31)
                    return "Periodo máximo de consulta 31 dias. Favor de verificar."
            }
            return true;
        },
        validaInicio: function(){
            if (this.model.fecha_de != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment("2019-11-25", "YYYY-MM-DD"); //JEMM (22-05-2020): LOURDES indica que solo debe consultarte a partir de esta fecha
                var diferencia = fin.diff(inicio, 'days')
                if (inicio < fin)
                    return "Las líneas de captura están disponibles a partir de 2019-11-25"
            }
            return true;
        },
        maxListaRule: function () {
            if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
                return "Lista vacia";
            }

            let x = this.model.lista.split("\n");

            if (x.length > 50) {
                return "No se puede consultar mas de 50 pedimentos";
            }

            return true;
        },
        cargar: function () {
            if (this.model.rfc == null || this.model.rfc == "") {
                return false;
            }
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                tipo: this.model.tipo
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterioPredeterminados(this.datos[k].criterio);
                        }
                    }
                })
                .catch(err => {

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        cargartxt: function () {
            if (this.model.rfc == null || this.model.rfc == "") {
                return false;
            }
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                tipo: "LineasCapturaTXT"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datostxt = res.data;
                        this.datostxt.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datostxt) {
                            this.datostxt[k].fecha_solicitud = this.parseDate(this.datostxt[k].fecha_solicitud);
                            this.datostxt[k].fecha_generacion = this.parseDate(this.datostxt[k].fecha_generacion);
                            this.datostxt[k].estatus = this.getEstatus(this.datostxt[k].estatus);
                            this.datostxt[k].criterio = this.getCriterioPredeterminados(this.datostxt[k].criterio);
                        }
                    }
                })
                .catch(err => {

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getEstatus: function (estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        getCriterioPredeterminados: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    if (params.tipo_reporte == 1) {
                        return "Pedimento: " + params.pedimento;
                    } else if (params.tipo_reporte == 3) {
                        return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    } else if (params.tipo_reporte == 4) {
                        return "Búsqueda por listado de pedimentos";
                    }
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }

        },
        get_data_view: function () {
            if (!this.$refs.form1.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = this.model;
                if (data.pedimento == '') delete(data['pedimento']);
                if (data.fecha_de == '') delete(data['fecha_de']);
                if (data.fecha_a == '') delete(data['fecha_a']);
                if (data.lista == '' || data.lista == []) {
                    delete(data['lista'])
                } else {
                    if (data.tipo_reporte == 4) {
                        data['lista'] = this.get_array_lista(data['lista'])
                    }
                }

                axios({
                        method: "post",
                        url: this.$hostname + "reportes_ws/linea_captura_preview/",
                        data: data
                    })
                    .then(response => {
                        this.data_view.datos = response.data;
                        if (data.tipo_reporte == 4) {
                            this.model.lista = '';
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        let mensaje;
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }

                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        generar_reporte_sqs() {
            if (!this.$refs.form2.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = this.model;
                if (data.pedimento == '') delete(data['pedimento']);
                if (data.fecha_de == '') delete(data['fecha_de']);
                if (data.fecha_a == '') delete(data['fecha_a']);
                if (data.lista == '' || data.lista == []) {
                    delete(data['lista']);
                } else {
                    if (data.tipo_reporte == 4) {
                        data['lista'] = this.get_array_lista(data['lista']);
                    }
                }

                axios({
                        method: "post",
                        url: this.$hostname + "reportes/save_reporte/",
                        data: data
                    })
                    .then(response => {
                        if (data.tipo_reporte == 4) {
                            this.model.lista = '';
                        }
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406){
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        generar_reporte_txt() {
            if (!this.$refs.form3.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = Vue.util.extend({}, this.model);
                data["reporte_url"] = "/reportes_ws/linea_captura_txt/"
                data["nombre_reporte"] = "Lineas Captura TXT"
                data["tipo"] = "LineasCapturaTXT"
                if (data.pedimento == '') delete(data['pedimento']);
                if (data.fecha_de == '') delete(data['fecha_de']);
                if (data.fecha_a == '') delete(data['fecha_a']);
                if (data.lista == '' || data.lista == []) {
                    delete(data['lista']);
                } else {
                    if (data.tipo_reporte == 4) {
                        data['lista'] = this.get_array_lista(data['lista']);
                    }
                }

                axios({
                        method: "post",
                        url: this.$hostname + "reportes/save_reporte/",
                        //url: "http://127.0.0.1:7000/reportes_ws/linea_captura_txt/",
                        data: data
                    })
                    .then(response => {
                        if (data.tipo_reporte == 4) {
                            this.model.lista = '';
                        }
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406){
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.cargartxt();
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        validaMeses: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
                if (Math.abs(diferencia) > 92)
                    return "Periodo máximo de consulta 3 meses. Favor de verificar."
            }
            return true;
        },
        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },
          //Validamos números Float con punto decimal y que cumpla con el número de decimales
        verificaDecimales: function (valor, numeroDecimales) {
            var cantidad_split = valor.toString().split(".");
            if (cantidad_split.length == 1) {
                if (Number.isNaN(parseInt(cantidad_split[0]))) {
                    return false;
                } else
                    return parseInt(cantidad_split[0]).toString() + "." + "0".repeat(numeroDecimales);
            } else if (cantidad_split.length == 2) {
                if (Number.isNaN(parseInt(cantidad_split[0])) || Number.isNaN(parseInt(cantidad_split[1]))) {
                    return false;
                } else if (cantidad_split[1].toString().length > numeroDecimales) {
                    var newNum = Math.round(valor * Math.pow(10, numeroDecimales)) / Math.pow(10, numeroDecimales);
                    return this.verificaDecimales(newNum, numeroDecimales);
                } else {
                    var repetir = numeroDecimales - cantidad_split[1].toString().length;
                    if (repetir == 0)
                        return parseInt(cantidad_split[0]).toString() + "." + cantidad_split[1].toString();
                    else
                        return parseInt(cantidad_split[0]).toString() + "." + cantidad_split[1].toString() + "0".repeat(repetir);

                }

            } else
                return false;
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
            this.model.pedimento = '';
            this.model.fecha_de = '';
            this.model.fecha_a = '';
            this.model.lista = "";
            this.lista_filtrada = [];
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }

            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        downloadReporte: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = '_blank';
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        get_array_lista: function (cadena) {
            return cadena.split("\n");
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            var linea_captura = '';
            var aduana = '';
            var patente = '';
            var pedimento = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else {
                    for (var k in results) {

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {

                            let fechaOrig = results[k]["fecha"];
                            results[k]["fecha"] = thisObject.parseDateExcel(fechaOrig);
                            if (results[k]["fecha"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (results[k]["linea"]!=undefined) {
                                if (results[k]["linea"].toString().trim().length != 20 ) {
                                    if (results[k]["linea"].toString().trim().indexOf("VIRTUAL") == -1 && results[k]["linea"].toString().trim().indexOf("PAGADO") == -1 ) {
                                        errores++;
                                        errorTmp = "<br>- Linea Captura no válida: " + results[k]["linea"] + ", deben ser 20 caracteres o contener la palabra VIRTUAL o la palabra PAGADO";
                                        if (erroresText.indexOf(errorTmp) == -1)
                                            erroresText += errorTmp;
                                    }                                    
                                } else {
                                    linea_captura = results[k]["linea"].toString().trim();

                                    if (linea_captura.substring(0,2) != "03"){
                                        errores++;
                                        errorTmp = "<br>- Línea de Captura no válida: " + linea_captura + ", debe comenzar con '03' identificador exclusivo para comercio exterior.";
                                        if (erroresText.indexOf(errorTmp) == -1)
                                            erroresText += errorTmp;
                                    }

                                    if (results[k]["fecha"] != false){
                                        var anio = results[k]["fecha"].toString().substring(2,4);
                                        if (anio != linea_captura.substring(2,4)){
                                            errores++;
                                            errorTmp = "<br>- Línea de Captura no válida: después de '03', debe contener los últimos 2 digitos del año de la fecha de cargo.";
                                            if (erroresText.indexOf(errorTmp) == -1)
                                                erroresText += errorTmp;
                                        }
                                    }

                                    if (linea_captura.substring(10,12) != "P1"){
                                        errores++;
                                        errorTmp = "<br>- Línea de Captura no válida: debe contener el identificador tipo pedimento 'P1', verificar el formato.";
                                        if (erroresText.indexOf(errorTmp) == -1)
                                            erroresText += errorTmp;
                                    }

                                }
                            }
                            
                            aduana = results[k]["aduana"];
                            if (aduana != undefined && (aduana.toString().trim().length >2 || !Number.isInteger(aduana) )) {
                                errores++;
                                errorTmp = "<br>- Aduana no válida: " + results[k]["aduana"] + ", verificar el formato.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            patente = results[k]["patente"];
                            if (patente != undefined && (patente.toString().trim().length >4 || !Number.isInteger(patente) )) {
                                errores++;
                                errorTmp = "<br>- Patente no válida: " + results[k]["patente"] + ", verificar el formato.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if (results[k]["banco"].toString().trim().length > 99) {
                                errores++;
                                errorTmp = "<br>- Banco no válido: no se permite más de 100 caracteres.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            pedimento = results[k]["pedimento"];
                            if (pedimento != undefined && (pedimento.toString().trim().length > 7 || !Number.isInteger(pedimento) )) {
                                errores++;
                                errorTmp = "<br>- Pedimento no válido: " + results[k]["pedimento"] + ", verificar el formato.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }


                            if (thisObject.verificaDecimales(results[k]["importe"], 2) === false) {
                                errores++;
                                errorTmp = "<br>- Valor del importe no válido: " + results[k]["importe"] + ", debe ser un número válido con 2 decimales.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else
                                results[k]["importe"] = thisObject.verificaDecimales(results[k]["importe"], 2);

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }

        },
        handleSuccess: async function ({
                results,
                header
            }) {
            var errores = 0;
            var erroresText = '';
            this.importData = [];

            try {
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                } else {

                    for (var k in results) {
                        let linea_captura = "";
                        if (results[k]["linea"] != undefined)
                            linea_captura = results[k]["linea"].toString().trim();

                        let aduana = "";
                        let patente = "";
                        let pedimento = "";
                        if (results[k]["aduana"]!=undefined){
                            var padAduana = "00";
                            aduana = results[k]["aduana"].toString().trim();
                            aduana = (padAduana + aduana).slice(-padAduana.length);
                        }

                        if (results[k]["patente"]!=undefined){
                            var padPatente = "0000";
                            patente = results[k]["patente"].toString().trim();
                            patente = (padPatente + patente).slice(-padPatente.length);
                        }

                        if (results[k]["pedimento"]!=undefined){
                            var padPedimento = "0000000";
                            pedimento = results[k]["pedimento"].toString().trim();
                            pedimento = (padPedimento + pedimento).slice(-padPedimento.length);
                        }


                        this.importData.push({
                            banco: results[k]["banco"].toString().trim(),
                            importe: results[k]["importe"],
                            fecha: results[k]["fecha"],
                            linea_captura: linea_captura,
                            aduana: aduana,
                            patente: patente,
                            pedimento: pedimento,
                            otros: results[k]["otros"],
                            localizado: "",
                            aplicado: "",
                            numero_operacion_bancaria: results[k]["numero_operacion_bancaria"],
                            numero_transaccion_sat: results[k]["numero_transaccion_sat"],
                        });
                    }
                    //console.log(this.importData);
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    let datos = {
                        rfc: this.model.rfc,
                        fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
                        usuario: this.$local_storage.get("id_usuario"),
                        pedimentos: this.importData,
                    };

                    axios
                        .post(this.URL_layout + "save_consulta/", datos)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El layout se cargó correctamente. Recibirá una notificación cuando el resultado esté disponible.",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            //console.log(err.response);
                            var errores = "";
                            if (err.response.data != undefined) {
                                if (err.response.data.mensaje != undefined) {
                                    if (typeof err.response.data.mensaje == "string")
                                        errores += err.response.data.mensaje;
                                    else
                                        errores += err.response.data.mensaje[0];

                                } else {
                                    Object.keys(err.response.data).forEach(function (key) {
                                        errores += key + ": " + err.response.data[key];
                                        errores += "<br>";
                                    });

                                }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                            this.$root.$dialogLoader.hide();
                        })
                        .then(() => {
                            this.cargarConsultas();
                        });

                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        cargarConsultas: function () {
            if (this.model.rfc == null || this.model.rfc == "") {
                return false;
            }
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
            };
            axios.post(this.URL_layout + "get_consultas/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.consulta.items = res.data;
                        this.consulta.items.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_creacion) - new Date(a.fecha_creacion) ;
                        });
                        for (var k in this.consulta.items) {
                            this.consulta.items[k].fecha_creacion = this.parseDate(this.consulta.items[k].fecha_creacion);
                            this.consulta.items[k].fecha_actualizacion = this.parseDate(this.consulta.items[k].fecha_actualizacion);
                        }
                    }
                })
                .catch(err => {

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        verificaDetalle: function(id_linea){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                id: id_linea,
                usuario: this.$local_storage.get("id_usuario")
            };
            axios.post(this.URL_layout + "verifica_consulta/", data)
                .then(res => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "Los registros se verificaron correctamente.",
                        footer: ""
                    });
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al verificar los registros.",
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.cargarConsultas();
                });
        },
        getDetalle: function(id_linea){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                id: id_linea,
                rfc: this.model.rfc
            };
            axios.post(this.URL_layout + "get_detalle_consultas/", data)
                .then(res => {
                    this.data_detalle = res.data;
                    for (var k in this.data_detalle){
                        this.data_detalle[k].fecha = this.parseDate(this.data_detalle[k].fecha);
                    }
                    this.modal = true;
                })
                .catch(err => {
                    console.log(err);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los detalles.",
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();
                        this.cargartxt();
                    });
              }
          });
        },
    },//methods
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small ;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small ;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}
.elevation-1 >>> #VueTables_th--Referencia{
    min-width: 350px !important;
}

.elevation-2 >>> #VueTables_th--localizado
{
    min-width: 450px !important;
}
.elevation-2 >>> .columnaCriterio {
  white-space: normal !important;
  max-width: 450px !important;
  text-align: justify !important;
}
</style>
